import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StartChat from "./StartChat";

const CustomNoti = React.memo(({ isOpen, onClose, notification, index, type }) => {
  const modalTop = 1 + index * 1 + "%";
  const navigate = useNavigate();

  const typesRequiringHotelFields = [
    "Hotel",
    "My Work place",
    "School premises",
    "Funeral Ground",
    "Working site",
    "Farmland",
    "Sports complex",
    "Home",
  ];

  return (
    <>
      <Modal
        open={isOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          if (reason === "escapeKeyDown") return;
          onClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pt: modalTop,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            width: 600,
            maxWidth: "90%",
            p: 3,
            boxShadow: 24,
          }}
        >
          <div className="row">
            <h5 className="text-dark text-end pe-4" onClick={onClose} style={{ cursor: "pointer" }}>
              X
            </h5>
            <h5 className="text-center pt-0 text-danger" style={{ marginTop: -15 }}>
              {type} - {notification?.userName}
            </h5>
            <div className="col-7 ms-4 mt-4">
              <p className="fs-6">
                <span className="fw-bold">User Name :</span> {notification?.userName} <br />
                <span className="fw-bold">User Phone :</span> {notification?.userPhone} <br />
                <span className="fw-bold">User Email :</span> {notification?.userEmail} <br />
                <span className="fw-bold">Location Type :</span> {notification?.locationType}
                <br />
                {typesRequiringHotelFields.includes(notification?.locationType) && (
                  <>
                    <span className="fw-bold">Location Address :</span> {notification?.hotelName}
                    <br />
                    <span className="fw-bold">Comment :</span> {notification?.hotelDescription}
                    <br />
                  </>
                )}
                <span className="fw-bold">Address :</span> {notification?.Place}
                <br />
                <span className="fw-bold">Staying Partner Relationship :</span>{" "}
                {notification?.PartnerRelation}
                <br />
                <span className="fw-bold">Partner Name :</span> {notification?.PartnerName}{" "}
                {notification?.PartnerLastName}
                <br />
                <span className="fw-bold">Partner Mobile number :</span>{" "}
                {notification?.PartnerMobileNo}
                <br />
                <span className="fw-bold">Geo-Fencing :</span> Enabled
                <br />
                <span className="fw-bold">Date :</span> {notification?.Date}
                <br />
                <span className="fw-bold">Start Time :</span> {notification?.Time}
                <br />
                <span className="fw-bold">Interval :</span> {notification?.Interval}
                <br />
                <span className="fw-bold">Communication Mode:</span> {notification?.checkInType}
                <br />
                <span className="fw-bold">Battery Level : </span>
                {notification?.BatteryIndicator != null && !isNaN(notification?.BatteryIndicator)
                  ? `${(notification.BatteryIndicator * 100).toFixed(0)}%`
                  : "N/A"}
                <br />
              </p>
            </div>

            <div className="col mt-2">
              <img
                className="mt-4"
                style={{ backgroundSize: "cover" }}
                alt="no image attached by user"
                height={170}
                width={170}
                src={notification?.userSelfie}
              />
              <div className="row mt-2">
                <div>
                  {notification?.LiveLatitude && notification?.LiveLongitude ? (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-danger form-control-sm form-control mb-1"
                      style={{ fontSize: 12 }}
                      href={`https://maps.google.com/?q=${notification.LiveLatitude},${notification.LiveLongitude}`}
                    >
                      {`https://maps.google.com/?q=${notification.LiveLatitude},${notification.LiveLongitude}`}
                    </a>
                  ) : null}
                </div>
                <div className="col mt-1">
                  <button
                    className="btn btn-warning btn-sm pe-1 ps-1"
                    onClick={() => {
                      navigate(`/VitualWellBeingHomeCheck`);
                      onClose();
                    }}
                  >
                    Start Check
                  </button>

                  <button
                    className="btn btn-primary btn-sm ms-1"
                    onClick={() => {
                      onClose();
                      navigate(`/VitualWellBeingHomeCheck`);
                    }}
                  >
                    See Profile
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
});

export default CustomNoti;
